// utils/translations.js

export const teamNames = {
    "CA Paranaense": "اتلتیکو پارانائنزه",
    "Coritiba FBC": "کوریتیبا",
    "Clube do Remo": "رمو",
    "Chapecoense AF": "شاپه‌کوئنزه",
    "Arsenal FC": "آرسنال",
    "Aston Villa FC": "استون ویلا",
    "AFC Bournemouth": "بورنموث",
    "Brentford FC": "برنتفورد",
    "Brighton & Hove Albion FC": "برایتون",
    "Chelsea FC": "چلسی",
    "Crystal Palace FC": "کریستال پالاس",
    "Everton FC": "اورتون",
    "Fulham FC": "فولام",
    "Leicester City FC": "لسترسیتی",
    "Liverpool FC": "لیورپول",
    "Manchester City FC": "منچستر سیتی",
    "Manchester United FC": "منچستر یونایتد",
    "Newcastle United FC": "نیوکاسل",
    "Nottingham Forest FC": "ناتینگهام فارست",
    "Southampton FC": "ساوتهمپتون",
    "Sunderland AFC": "ساندرلند",
    "Tottenham Hotspur FC": "تاتنهام",
    "West Ham United FC": "وست‌هم",
    "Wolverhampton Wanderers FC": "ولورهمپتون",
    "Burnley FC": "برنلی",
    "Leeds United FC": "لیدز یونایتد",
    "Hull City AFC": "هال سیتی",
    "Coventry City FC": "کاونتری سیتی",
    "Ipswich Town FC": "ایپسویچ تاون",
    "Sheffield United FC": "شفیلد یونایتد",
    "Sheffield Wednesday FC": "شفیلد ونزدی",
    "Derby County FC": "داربی کانتی",
    "Oxford United FC": "آکسفورد یونایتد",
    "Queens Park Rangers FC": "کیوپی‌آر (کویینز پارک رنجرز)",
    "Blackburn Rovers FC": "بلکبرن راورز",
    "Charlton Athletic FC": "چارلتون اتلتیک",
    "Wrexham AFC": "رکسهام",
    "Portsmouth FC": "پورتسموث",
    "Preston North End FC": "پرستون نورث‌اند",
    "Birmingham City FC": "بیرمنگام سیتی",
    "Millwall FC": "میلوال",
    "Norwich City FC": "نوریچ سیتی",
    "Stoke City FC": "استوک سیتی",
    "Watford FC": "واتفورد",
    "Swansea City AFC": "سوانزی سیتی",
    "Bristol City FC": "بریستول سیتی",
    "Middlesbrough FC": "میدلزبرو",
    "West Bromwich Albion FC": "وست برومویچ",

    "Paris Saint-Germain FC": "پاری سن ژرمن",
    "Lille OSC": "لیل",
    "Olympique Lyonnais": "المپیک لیون",
    "Racing Club de Lens": "رنسیس",
    "RC Strasbourg Alsace": "استراسبورگ",
    "Toulouse FC": "تولوز",
    "Angers SCO": "انژه",
    "Stade Rennais FC 1901": "رن",
    "Olympique de Marseille": "المپیک مارسی",
    "AS Monaco FC": "موناکو",
    "OGC Nice": "نیس",
    "FC Nantes": "نانت",
    "AJ Auxerre": "اوکسیر",
    "FC Lorient": "لوریان",
    "Stade Brestois 29": "بُرس",
    "Le Havre AC": "لو آور",
    "Paris FC": "پاریس اف‌سی",
    "FC Metz": "متز",

    "FC Bayern München": "بایرن مونیخ",
    "Eintracht Frankfurt": "آینتراخت فرانکفورت",
    "FC St. Pauli 1910": "سن پائولی",
    "VfL Wolfsburg": "ولفسبورگ",
    "FC Augsburg": "آوگسبورگ",
    "1. FC Union Berlin": "یونیون برلین",
    "1. FC Köln": "کلن",
    "VfB Stuttgart": "اشتوتگارت",
    "TSG 1899 Hoffenheim": "هوفن‌هایم",
    "RB Leipzig": "لایپزیگ",
    "Borussia Dortmund": "دورتموند",
    "Bayer 04 Leverkusen": "بایرلورکوزن",
    "Borussia Mönchengladbach": "مونشن‌گلادباخ",
    "Hamburger SV": "هامبورگ",
    "SV Werder Bremen": "وردر برمن",
    "1. FSV Mainz 05": "ماینتس",
    "SC Freiburg": "فریبورگ",
    "1. FC Heidenheim 1846": "هایندهایم",
    "SC Paderborn 07": "پادربورن",
    "SV 07 Elversberg": "الورسبرگ",

    "SSC Napoli": "ناپولی",
    "US Cremonese": "کرِمونِزه",
    "AS Roma": "آاس رم",
    "FC Internazionale Milano": "اینتر میلان",
    "Juventus FC": "یوونتوس",
    "AC Milan": "آث میلان",
    "Como 1907": "کومو",
    "Bologna FC 1909": "بولونیا",
    "Atalanta BC": "آتلانتا",
    "ACF Fiorentina": "فیورنتینا",
    "Hellas Verona FC": "هللاس ورونا",
    "Udinese Calcio": "اودینزه",
    "Genoa CFC": "جنوا",
    "Cagliari Calcio": "کالیاری",
    "AC Pisa 1909": "پیزا",
    "Parma Calcio 1913": "پارما",
    "US Lecce": "لچه",
    "SS Lazio": "لاتزیو",
    "US Sassuolo Calcio": "ساسولو",
    "Torino FC": "تورینو",

    "NEC": "ان‌ای‌سی نایمخن",
    "PSV": "پی‌اس‌وی آیندهوون",
    "AFC Ajax": "آژاکس آمستردام",
    "FC Utrecht": "اوترخت",
    "Feyenoord Rotterdam": "فاینورد روتردام",
    "PEC Zwolle": "پک زووله",
    "Sparta Rotterdam": "اسپارتا روتردام",
    "FC Groningen": "خرونینگن",
    "AZ": "آزد آلکمار",
    "FC Volendam": "ولندام",
    "Fortuna Sittard": "فورتونا سیتارد",
    "Telstar 1963": "تلستار",
    "Go Ahead Eagles": "گو آهد ایگلز",
    "FC Twente '65": "توئنته",
    "NAC Breda": "ان‌ای‌سی برِدا",
    "SBV Excelsior": "اکسلسیور روتردام",
    "SC Heerenveen": "هیرنفین",
    "Heracles Almelo": "هرکولس آلملو",

    "FC Porto": "پورتو",
    "FC Famalicão": "فامالیکائو",
    "Sporting Clube de Portugal": "اسپورتینگ لیسبون",
    "Moreirense FC": "موریرنسه",
    "Sporting Clube de Braga": "برگا",
    "Gil Vicente FC": "ژیل وینسنت",
    "Sport Lisboa e Benfica": "بنفیکا",
    "FC Arouca": "آروکا",
    "CD Nacional": "ناسیونال مادیره",
    "Vitória SC": "ویتوریا گیمارش",
    "Casa Pia AC": "کازا پیا",
    "Rio Ave FC": "ریو آوه",
    "CF Estrela da Amadora": "استرلا آمارادورا",
    "GD Estoril Praia": "استوریل پرایا",
    "FC Alverca": "آلورکا",
    "AVS": "ای‌وی‌اس",
    "CD Santa Clara": "سانتا کلارا",
    "CD Tondela": "تونديلا",

    "Real Madrid CF": "رئال مادرید",
    "Villarreal CF": "ویارئال",
    "FC Barcelona": "بارسلونا",
    "Athletic Club": "آتلتیک بیلبائو",
    "Getafe CF": "ختافه",
    "Elche CF": "الخیه",
    "Real Betis Balompié": "رئال بتیس",
    "Valencia CF": "والنسیا",
    "RCD Espanyol de Barcelona": "اسپانیول",
    "Deportivo Alavés": "آلاوس",
    "Rayo Vallecano de Madrid": "رایو وایکانو",
    "Sevilla FC": "سویا",
    "CA Osasuna": "اوساسونا",
    "Real Oviedo": "رئال اووییدو",
    "Club Atlético de Madrid": "اتلتیکومادرید",
    "Real Sociedad de Fútbol": "رئال سوسیداد",
    "RC Celta de Vigo": "سلتاویگو",
    "RCD Mallorca": "مایورکا",
    "Levante UD": "لوانته",
    "Girona FC": "خیخونا",

    "CR Flamengo": "فلامنگو",
    "Cruzeiro EC": "کروزئیرو",
    "SE Palmeiras": "پالمیراس",
    "EC Bahia": "باهیا",
    "Botafogo FR": "بوتافوگو",
    "Mirassol FC": "میرسول",
    "São Paulo FC": "سائو پائولو",
    "RB Bragantino": "براگانتینو",
    "Fluminense FC": "فلومیننزه",
    "Ceará SC": "سیارا",
    "SC Corinthians Paulista": "کورینتیانس",
    "CA Mineiro": "اتلتیکو مینیرو",
    "SC Internacional": "اینترناسیونال",
    "Grêmio FBPA": "گرميو",
    "Santos FC": "سانتوس",
    "EC Juventude": "جوانتوده",
    "CR Vasco da Gama": "واسکو دا گاما",
    "EC Vitória": "ویتوریا",
    "Fortaleza EC": "فورتالزا",
    "SC Recife": "اسپورت رسیفه",

    "Estudiantes de La Plata": "استودیانتس د لا پلاتا",
    "CF Universidad de Chile": "دانشگاه شیلی",
    "Carabobo FC": "کارابوبو",
    "Club Brugge KV": "کلوب بروژ",
    "FC København": "کپنهاگن",
    "FK Bodø/Glimt": "بودو گلیمت",
    "FK Kairat": "کایرات",
    "Galatasaray SK": "گالاتاسرای",
    "PAE Olympiakos SFP": "المپیاکوس",
    "Qarabağ Ağdam FK": "قره‌باغ آغدام",
    "SK Slavia Praha": "اسلاویا پراگ",
    "Royale Union Saint-Gilloise": "رویال یونیون سنت ژیلواز",
    "Paphos FC": "پافوس",
};

export const matchStatus = {
    "SCHEDULED": "برنامه‌ریزی‌شده",
    "TIMED": "زمان‌بندی‌شده",
    "IN_PLAY": "در حال بازی",
    "PAUSED": "معلق",
    "EXTRA_TIME": "وقت اضافه",
    "PENALTY_SHOOTOUT": "ضربات پنالتی",
    "FINISHED": "پایان یافته",
    "SUSPENDED": "تعلیق‌شده",
    "POSTPONED": "تعویق‌خورده",
    "CANCELLED": "لغو شده",
    "AWARDED": "اعطا شده"
};

export const leagueNames = {
    "لیگ برتر": "لیگ برتر ایران",
    "PL": "لیگ برتر انگلیس",
    "ELC": "چمپیونشیپ انگلیس",
    "PD": "لالیگا اسپانیا",
    "SA": "سری آ ایتالیا",
    "BL1": "بوندسلیگا آلمان",
    "FL1": "لیگ ۱ فرانسه",
    "BSA": "لیگ برزیل",
    "CL": "لیگ قهرمانان اروپا",
    "EC": "مسابقات قهرمانی اروپا",
    "DED": "لیگ هلند",
    "PPL": "لیگ پرتقال",
    "WC": "جام جهانی فیفا",
    "CLI": "آمریکای شمالی",
    "UNL": "لیگ ملت‌های اروپا",
    "WCQ-AFC": "مقدماتی جام جهانی آسیا",
    "FRL": "دوستانهٔ تیم‌های ملی",
};

export const teamNamesByLeague = {
    PL: {
        "Arsenal FC": "آرسنال",
        "Aston Villa FC": "استون ویلا",
        "AFC Bournemouth": "بورنموث",
        "Brentford FC": "برنتفورد",
        "Brighton & Hove Albion FC": "برایتون",
        "Chelsea FC": "چلسی",
        "Crystal Palace FC": "کریستال پالاس",
        "Everton FC": "اورتون",
        "Fulham FC": "فولام",
        "Leicester City FC": "لسترسیتی",
        "Liverpool FC": "لیورپول",
        "Manchester City FC": "منچستر سیتی",
        "Manchester United FC": "منچستر یونایتد",
        "Newcastle United FC": "نیوکاسل",
        "Nottingham Forest FC": "ناتینگهام فارست",
        "Southampton FC": "ساوتهمپتون",
        "Sunderland AFC": "ساندرلند",
        "Tottenham Hotspur FC": "تاتنهام",
        "West Ham United FC": "وست‌هم",
        "Wolverhampton Wanderers FC": "ولورهمپتون",
        "Burnley FC": "برنلی",
        "Leeds United FC": "لیدز یونایتد",
        "Hull City AFC": "هال سیتی",
        "Coventry City FC": "کاونتری سیتی",
        "Ipswich Town FC": "ایپسویچ تاون",
        "Sheffield United FC": "شفیلد یونایتد",
        "Sheffield Wednesday FC": "شفیلد ونزدی",
        "Derby County FC": "داربی کانتی",
        "Oxford United FC": "آکسفورد یونایتد",
        "Queens Park Rangers FC": "کیوپی‌آر (کویینز پارک رنجرز)",
        "Blackburn Rovers FC": "بلکبرن راورز",
        "Charlton Athletic FC": "چارلتون اتلتیک",
        "Wrexham AFC": "رکسهام",
        "Portsmouth FC": "پورتسموث",
        "Preston North End FC": "پرستون نورث‌اند",
        "Birmingham City FC": "بیرمنگام سیتی",
        "Millwall FC": "میلوال",
        "Norwich City FC": "نوریچ سیتی",
        "Stoke City FC": "استوک سیتی",
        "Watford FC": "واتفورد",
        "Swansea City AFC": "سوانزی سیتی",
        "Bristol City FC": "بریستول سیتی",
        "Middlesbrough FC": "میدلزبرو",
        "West Bromwich Albion FC": "وست برومویچ",
    },
    FL1: {
        "Paris Saint-Germain FC": "پاری سن ژرمن",
        "Lille OSC": "لیل",
        "Olympique Lyonnais": "المپیک لیون",
        "Racing Club de Lens": "رنسیس",
        "RC Strasbourg Alsace": "استراسبورگ",
        "Toulouse FC": "تولوز",
        "Angers SCO": "انژه",
        "Stade Rennais FC 1901": "رن",
        "Olympique de Marseille": "المپیک مارسی",
        "AS Monaco FC": "موناکو",
        "OGC Nice": "نیس",
        "FC Nantes": "نانت",
        "AJ Auxerre": "اوکسیر",
        "FC Lorient": "لوریان",
        "Stade Brestois 29": "بُرس",
        "Le Havre AC": "لو آور",
        "Paris FC": "پاریس اف‌سی",
        "FC Metz": "متز",
    },
    BL1: {
        "FC Bayern München": "بایرن مونیخ",
        "Eintracht Frankfurt": "آینتراخت فرانکفورت",
        "FC St. Pauli 1910": "سن پائولی",
        "VfL Wolfsburg": "ولفسبورگ",
        "FC Augsburg": "آوگسبورگ",
        "FC Union Berlin": "یونیون برلین",
        "FC Köln": "کلن",
        "VfB Stuttgart": "اشتوتگارت",
        "TSG 1899 Hoffenheim": "هوفن‌هایم",
        "RB Leipzig": "لایپزیگ",
        "Borussia Dortmund": "دورتموند",
        "Bayer 04 Leverkusen": "بایرلورکوزن",
        "Borussia Mönchengladbach": "مونشن‌گلادباخ",
        "Hamburger SV": "هامبورگ",
        "SV Werder Bremen": "وردر برمن",
        "FSV Mainz 05": "ماینتس",
        "SC Freiburg": "فریبورگ",
        "FC Heidenheim": "هایندهایم",
        "SC Paderborn 07": "پادربورن",
        "SV 07 Elversberg": "الورسبرگ",
    },
    SA: {
        "SSC Napoli": "ناپولی",
        "US Cremonese": "کرِمونِزه",
        "AS Roma": "آاس رم",
        "FC Internazionale Milano": "اینتر میلان",
        "Juventus FC": "یوونتوس",
        "AC Milan": "آث میلان",
        "Como 1907": "کومو",
        "Bologna FC 1909": "بولونیا",
        "Atalanta BC": "آتلانتا",
        "ACF Fiorentina": "فیورنتینا",
        "Hellas Verona FC": "هللاس ورونا",
        "Udinese Calcio": "اودینزه",
        "Genoa CFC": "جنوا",
        "Cagliari Calcio": "کالیاری",
        "AC Pisa 1909": "پیزا",
        "Parma Calcio 1913": "پارما",
        "US Lecce": "لچه",
        "SS Lazio": "لاتزیو",
        "US Sassuolo Calcio": "ساسولو",
        "Torino FC": "تورینو",
    },
    DED: {
        "NEC": "ان‌ای‌سی نایمخن",
        "PSV": "پی‌اس‌وی آیندهوون",
        "AFC Ajax": "آژاکس آمستردام",
        "FC Utrecht": "اوترخت",
        "Feyenoord Rotterdam": "فاینورد روتردام",
        "PEC Zwolle": "پک زووله",
        "Sparta Rotterdam": "اسپارتا روتردام",
        "FC Groningen": "خرونینگن",
        "AZ": "آزد آلکمار",
        "FC Volendam": "ولندام",
        "Fortuna Sittard": "فورتونا سیتارد",
        "Telstar 1963": "تلستار",
        "Go Ahead Eagles": "گو آهد ایگلز",
        "FC Twente '65": "توئنته",
        "NAC Breda": "ان‌ای‌سی برِدا",
        "SBV Excelsior": "اکسلسیور روتردام",
        "SC Heerenveen": "هیرنفین",
        "Heracles Almelo": "هرکولس آلملو",
    },
    PPL: {
        "FC Porto": "پورتو",
        "FC Famalicão": "فامالیکائو",
        "Sporting Clube de Portugal": "اسپورتینگ لیسبون",
        "Moreirense FC": "موریرنسه",
        "Sporting Clube de Braga": "برگا",
        "Gil Vicente FC": "ژیل وینسنت",
        "Sport Lisboa e Benfica": "بنفیکا",
        "FC Arouca": "آروکا",
        "CD Nacional": "ناسیونال مادیره",
        "Vitória SC": "ویتوریا گیمارش",
        "Casa Pia AC": "کازا پیا",
        "Rio Ave FC": "ریو آوه",
        "CF Estrela da Amadora": "استرلا آمارادورا",
        "GD Estoril Praia": "استوریل پرایا",
        "FC Alverca": "آلورکا",
        "AVS": "ای‌وی‌اس",
        "CD Santa Clara": "سانتا کلارا",
        "CD Tondela": "تونديلا",
    },
    PD: {
        "Real Madrid CF": "رئال مادرید",
        "Villarreal CF": "ویارئال",
        "FC Barcelona": "بارسلونا",
        "Athletic Club": "آتلتیک بیلبائو",
        "Getafe CF": "ختافه",
        "Elche CF": "الخیه",
        "Real Betis Balompié": "رئال بتیس",
        "Valencia CF": "والنسیا",
        "RCD Espanyol de Barcelona": "اسپانیول",
        "Deportivo Alavés": "آلاوس",
        "Rayo Vallecano de Madrid": "رایو وایکانو",
        "Sevilla FC": "سویا",
        "CA Osasuna": "اوساسونا",
        "Real Oviedo": "رئال اووییدو",
        "Club Atlético de Madrid": "اتلتیکومادرید",
        "Real Sociedad de Fútbol": "رئال سوسیداد",
        "RC Celta de Vigo": "سلتاویگو",
        "RCD Mallorca": "مایورکا",
        "Levante UD": "لوانته",
        "Girona FC": "خیخونا",
    },
    BSA: {
        "R Flamengo": "فلامنگو",
        "Cruzeiro EC": "کروزئیرو",
        "SE Palmeiras": "پالمیراس",
        "EC Bahia": "باهیا",
        "Botafogo FR": "بوتافوگو",
        "Mirassol FC": "میرسول",
        "São Paulo FC": "سائو پائولو",
        "RB Bragantino": "براگانتینو",
        "Fluminense FC": "فلومیننزه",
        "Ceará SC": "سیارا",
        "SC Corinthians Paulista": "کورینتیانس",
        "CA Mineiro": "اتلتیکو مینیرو",
        "SC Internacional": "اینترناسیونال",
        "Grêmio FBPA": "گرميو",
        "Santos FC": "سانتوس",
        "EC Juventude": "جوانتوده",
        "CR Vasco da Gama": "واسکو دا گاما",
        "EC Vitória": "ویتوریا",
        "Fortaleza EC": "فورتالزا",
        "SC Recife": "اسپورت رسیفه",
        "CoritibaFBC": "کوریتیبا",
        "CA Paranaense": "اتلتیکو پارانائنزه",
        "Coritiba FBC": "کوریتیبا",
        "Clube do Remo": "رمو",
        "Chapecoense AF": "شاپه‌کوئنزه",
    },
    ELC: {
        "Middlesbrough FC": "میدلزبرو",
        "West Bromwich Albion FC": "وست برومویچ",
        "Stoke City FC": "استوک سیتی",
        "Leicester City FC": "لسترسیتی",
        "Coventry City FC": "کاونتری سیتی",
        "Bristol City FC": "بریستول سیتی",
        "Swansea City AFC": "سوانزی سیتی",
        "Portsmouth FC": "پورتسموث",
        "Preston North End FC": "پرستون نورث‌اند",
        "Birmingham City FC": "بیرمنگام سیتی",
        "Norwich City FC": "نوریچ سیتی",
        "Millwall FC": "میلوال",
        "Southampton FC": "ساوتهمپتون",
        "Watford FC": "واتفورد",
        "Wrexham AFC": "رکسهام",
        "Charlton Athletic FC": "چارلتون اتلتیک",
        "Hull City AFC": "هال سیتی",
        "Queens Park Rangers FC": "کیوپی‌آر (کویینز پارک رنجرز)",
        "Blackburn Rovers FC": "بلکبرن راورز",
        "Ipswich Town FC": "ایپسویچ تاون",
        "Derby County FC": "داربی کانتی",
        "Oxford United FC": "آکسفورد یونایتد",
        "Sheffield Wednesday FC": "شفیلد ونزدی",
        "Sheffield United FC": "شفیلد یونایتد",
    }
};

export const leagueNamesLatin = {
    "Premier League": "لیگ برتر انگلیس",
    "Primera Division": "لالیگا اسپانیا",
    "Serie A": "سری آ ایتالیا",
    "Bundesliga": "بوندسلیگا آلمان",
    "Primeira Liga": "لیگ پرتقال",
    "Eredivisie": "لیگ هلند",
    "Campeonato Brasileiro Série A": "لیگ برزیل",
    "Championship": "چمپیونشیپ انگلیس",
    "Ligue 1": "لیگ ۱ فرانسه",
    "UEFA Champions League": "لیگ قهرمانان اروپا",
    "UEFA Europa League": "لیگ اروپا",
    "FIFA World Cup": "جام جهانی فیفا",
    "Copa Libertadores": "کوپا لیبرتادورز",
    "CONMEBOL Sudamericana": "کوپا سودامریکانا",
    "UEFA Nations League": "لیگ ملت‌های اروپا",
    "AFC Champions League": "لیگ قهرمانان آسیا",
    "MLS": "لیگ آمریکا",
    "Major League Soccer": "لیگ آمریکا",
};

// تبدیل ارقام لاتین به فارسی
const toFaDigits = s => String(s).replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);

/**
 * برچسب فارسی «هفته / مرحله» برای نمایش در UI.
 * ورودی می‌تواند هرکدام از این‌ها باشد:
 *  - مقدار stage انگلیسی (مثل REGULAR_SEASON) که قبلاً در دیتابیس ذخیره شده
 *  - رشتهٔ round واقعی (مثل «Regular Season - 5»)
 * خروجی:
 *  - رشتهٔ خالی یعنی «نمایش نده» (مثل REGULAR_SEASON یا مقادیر ENUM ناآشنا)
 */
export function roundLabel(value) {
    if (value === null || value === undefined) return '';
    const v = String(value).trim();
    if (!v) return '';

    // هفته‌های لیگ: «Regular Season - 5» / «Matchday 5» / «Week 5»
    let m = v.match(/^Regular\s+Season\s*-\s*(\d+)$/i);
    if (m) return `هفتهٔ ${toFaDigits(m[1])}`;
    m = v.match(/^Matchday\s*[- ]?\s*(\d+)$/i);
    if (m) return `هفتهٔ ${toFaDigits(m[1])}`;
    m = v.match(/^Week\s*[- ]?\s*(\d+)$/i);
    if (m) return `هفتهٔ ${toFaDigits(m[1])}`;

    // مراحل شناخته‌شده (stage انگلیسی + رشته‌های round جام‌ها)
    const known = {
        'REGULAR_SEASON': '',
        'GROUP_STAGE': 'مرحلهٔ گروهی',
        'LAST_32': 'یک‌سی‌ودوم نهایی',
        'LAST_16': 'یک‌هشتم نهایی',
        'QUARTER_FINALS': 'یک‌چهارم نهایی',
        'SEMI_FINALS': 'نیمه‌نهایی',
        'THIRD_PLACE': 'رده‌بندی',
        'FINAL': 'فینال',
        'Round of 16': 'یک‌هشتم نهایی',
        'Round of 32': 'یک‌سی‌ودوم نهایی',
        'Quarter-finals': 'یک‌چهارم نهایی',
        'Quarter-final': 'یک‌چهارم نهایی',
        'Semi-finals': 'نیمه‌نهایی',
        'Semi-final': 'نیمه‌نهایی',
        'Final': 'فینال',
        '3rd place final': 'رده‌بندی',
        'Play-offs': 'پلی‌آف',
        'Play-off': 'پلی‌آف',
    };
    if (Object.prototype.hasOwnProperty.call(known, v)) return known[v];

    // هر مقدار ENUM-مانند ناآشنا (حروف بزرگ + آندرلاین) نمایش داده نشود
    if (/^[A-Z0-9_]+$/.test(v)) return '';

    // متن آزاد (مثل «هفته 2» ورزش۳) — ارقام هم فارسی شوند
    return toFaDigits(v);
}

// نگاشت یکپارچهٔ همهٔ نام تیم‌ها (teamNames + همهٔ لیگ‌های teamNamesByLeague)
// فقط بار اول ساخته می‌شود (lazy)
let _allTeamNames = null;

function allTeamNames() {
    if (!_allTeamNames) {
        const merged = { ...teamNames };
        for (const code of Object.keys(teamNamesByLeague)) {
            const leagueMap = teamNamesByLeague[code] || {};
            for (const key of Object.keys(leagueMap)) {
                if (!(key in merged)) merged[key] = leagueMap[key];
            }
        }
        _allTeamNames = merged;
    }
    return _allTeamNames;
}

/**
 * نام فارسی تیم — اول دیکشنری سراسری، بعد دیکشنری‌های لیگ‌محور،
 * در غیر این صورت همان ورودی (برای نام‌های فارسی ورزش۳)
 */
export function teamNameFa(name) {
    if (!name) return '';
    return allTeamNames()[name] || name;
}

// =========================================================
// نام فارسی بازیکنان (کلید = نام انگلیسی football-data)
// هر اسمی که اینجا نباشد، به همان شکل انگلیسی نمایش داده می‌شود
// =========================================================
export const playerNames = {
    // ---------- لیگ برتر انگلیس ----------
    "Alisson Becker": "الیسون بکر",
    "Trent Alexander-Arnold": "ترنت الکساندر-آرنولد",
    "Andrew Robertson": "اندی رابرتسون",
    "Virgil van Dijk": "ویرجیل فان دایک",
    "Ibrahima Konaté": "ابراهیما کوناته",
    "Ryan Gravenberch": "رایان گراونبرخ",
    "Alexis Mac Allister": "الکسیس مک‌آلیستر",
    "Dominik Szoboszlai": "دومینیک سوبوسلای",
    "Mohamed Salah": "محمد صلاح",
    "Luis Díaz": "لوئیس دیاز",
    "Diogo Jota": "دیوگو ژوتا",
    "Darwin Núñez": "داروین نونیـز",
    "Cody Gakpo": "کودی گاکپو",
    "Florian Wirtz": "فلورین ویرتز",
    "Hugo Ekitiké": "اوگو اکیتیکه",
    "Milos Kerkez": "میلوش کرکز",
    "Jeremie Frimpong": "جرمی فریمپونگ",
    "Ederson Moraes": "ادرسون",
    "Bernardo Silva": "برناردو سیلوا",
    "Phil Foden": "فیل فودن",
    "Erling Haaland": "ارلینگ هالند",
    "Kevin De Bruyne": "کوین دی‌بروینه",
    "Rodri": "رودری",
    "Rúben Dias": "روبن دیاش",
    "Josko Gvardiol": "یوشکو گواردیول",
    "Kyle Walker": "کایل واکر",
    "Jack Grealish": "جک گرلیش",
    "Savinho": "ساوینیو",
    "Tijjani Reijnders": "تیجانی رایندرس",
    "Rayan Cherki": "رایان شرکی",
    "Omar Marmoush": "عمر مرموش",
    "Mateo Kovačić": "ماتهو کوواچیچ",
    "William Saliba": "ویلیام سالیبا",
    "Bukayo Saka": "بوکایو ساکا",
    "Martin Ødegaard": "مارتین اودگارد",
    "Gabriel Jesus": "گابریل ژسوس",
    "Gabriel Magalhães": "گابریل ماگالییشس",
    "Declan Rice": "دکلن رایس",
    "Kai Havertz": "کای هاورتس",
    "Leandro Trossard": "لئاندرو تروسار",
    "Gabriel Martinelli": "گابریل مارتینلی",
    "David Raya": "دیوید رایا",
    "Riccardo Calafiori": "ریکاردو کالافیوری",
    "Mikel Merino": "میکل مرینو",
    "Viktor Gyökeres": "ویکتور گیوکرش",
    "Noni Madueke": "نونی مادوکه",
    "Eberechi Eze": "ابره‌چی ازه",
    "Cole Palmer": "کول پالمر",
    "Nicolas Jackson": "نیکلاس جکسون",
    "Enzo Fernández": "انسو فرناندز",
    "Moisés Caicedo": "مویسس کایسدو",
    "Reece James": "ریس جیمز",
    "Levi Colwill": "لووی کولویل",
    "Robert Sánchez": "رابرت سانچز",
    "Pedro Neto": "پدرو نتو",
    "João Pedro": "ژائو پدرو",
    "Liam Delap": "لیام دلپ",
    "Alejandro Garnacho": "الخاندرو گارناتشو",
    "Matheus Cunha": "ماتئوس کونیا",
    "Bryan Mbeumo": "برایان مبئومو",
    "Bruno Fernandes": "برونو فرناندز",
    "Kobbie Mainoo": "کوبی ماینو",
    "Amad Diallo": "آماد دیالو",
    "Manuel Ugarte": "مانوئل اوگارته",
    "Patrick Dorgu": "پاتریک دورگو",
    "Alexander Isak": "الکساندر ایزاک",
    "Anthony Gordon": "آنتونی گوردون",
    "Bruno Guimarães": "برونو گیمارنش",
    "Sandro Tonali": "ساندرو تونالی",
    "Sven Botman": "سون بوتمن",
    "Nick Pope": "نیک پوپ",
    "Harvey Barnes": "هاروی بارنز",
    "Nick Woltemade": "نیک ولتماده",
    "Yoane Wissa": "یوآن ویسا",
    "Marcus Rashford": "مارکوس رشفورد",
    "Ollie Watkins": "الی واتکینز",
    "Morgan Rogers": "مورگان راجرز",
    "Youri Tielemans": "یوری تیله‌مانس",
    "Emiliano Martínez": "امیلیانو مارتینز",
    "Ezri Konsa": "ازری کونسا",
    "Antoine Semenyo": "آنتوان سمنیو",
    "Evanilson": "اوانیلسون",
    "Dominic Solanke": "دومینیک سولانکه",
    "James Maddison": "جیمز مدیسون",
    "Son Heung-Min": "سون هیونگ-مین",
    "Cristian Romero": "کریستیان رومرو",
    "Micky van de Ven": "میکی فان دن ون",
    "Mohammed Kudus": "محمد کودوس",
    "Xavi Simons": "زاوی سیمونز",
    "Randal Kolo Muani": "راندال کولو موآنی",
    "Jarrod Bowen": "جاررد بوون",
    "Lucas Paquetá": "لوکاس پاکتا",
    "Danny Welbeck": "دنی ولبک",
    "João Pedro Junqueira de Jesus": "ژائو پدرو",
    "Kaoru Mitoma": "کائورو میتوما",
    "Danny Ings": "دنی اینگز",

    // ---------- لالیگا ----------
    "Thibaut Courtois": "تیبو کورتوا",
    "Éder Militão": "ادر میلیتائو",
    "Antonio Rüdiger": "آنتونیو رودیگر",
    "Ferland Mendy": "فرلان مندی",
    "Trent Alexander Arnold": "ترنت الکساندر-آرنولد",
    "Aurélien Tchouaméni": "اورلین چوامنی",
    "Federico Valverde": "فدریکو والورده",
    "Jude Bellingham": "جود بلینگام",
    "Luka Modrić": "لوکا مودریچ",
    "Vinícius Júnior": "وینیسیوس جونیور",
    "Rodrygo Goes": "رودریگو",
    "Kylian Mbappé": "کیلیان امباپه",
    "Arda Güler": "آردا گولر",
    "Eduardo Camavinga": "ادواردو کاماوینگا",
    "Fran García": "فران گارسیا",
    "Dean Huijsen": "دین هایسن",
    "Álvaro Carreras": "آلوارو کارراس",
    "Gonzalo García": "گونسالو گارسیا",
    "Franco Mastantuono": "فرانکو ماستانتوانو",
    "Marc-André ter Stegen": "مارک-آندره تر اشتگن",
    "Pedri": "پدری",
    "Gavi": "گاوی",
    "Frenkie de Jong": "فرنکی دی یونگ",
    "Robert Lewandowski": "رابرت لواندوفسکی",
    "Lamine Yamal": "لامین یامال",
    "Raphinha": "رافینیا",
    "Ferran Torres": "فران تورس",
    "Jules Koundé": "ژول کونده",
    "Ronald Araújo": "رونالد آرائوخو",
    "Pau Cubarsí": "پائو کوبارسی",
    "Alejandro Balde": "الخاندرو بالده",
    "Dani Olmo": "دانی اولمو",
    "Fermín López": "فرمین لوپز",
    "Marcus Rashford Frame": "مارکوس رشفورد",
    "Joan García": "خوان گارسیا",
    "Jan Oblak": "یان اوبلاک",
    "Antoine Griezmann": "آنتوان گریزمن",
    "Álvaro Morata": "آلوارو موراتا",
    "Julian Alvarez": "خولیان آلوارز",
    "Alexander Sørloth": "الکساندر سورلوث",
    "Robin Le Normand": "رابین لو نورمان",
    "Koke": "کوکه",
    "Nico Williams": "نیکو ویلیامز",
    "Iñaki Williams": "اینیکی ویلیامز",
    "Oihan Sancet": "اویان سانتست",
    "Unai Simón": "اونای سیمون",
    "Mikel Oyarzabal": "میکل اویارزابال",
    "Takefusa Kubo": "تکه‌فوسا کوبو",
    "Vinícius Júnior Júnior": "وینیسیوس جونیور",
    "Ander Barrenetxea": "آندر بارنتکسئا",
    "Borja Iglesias": "بورخا ایگلسیاس",
    "Isco": "ایسکو",
    "Djené Dakonam": "دژنه داکونام",
    "Álvaro Rodríguez": "آلوارو رودریگز",
    "Ayoze Pérez": "آیوزه پرز",
    "Iker Muniain": "ایکر مونیاین",
    "Sergi Cardona": "سرجی کاردونا",
    "Pere Milla": "پره میلیا",
    "Kike García": "کیکه گارسیا",
    "Hugo Duro": "اوگو دورو",
    "Diego López": "دیگو لوپز",

    // ---------- سری آ ----------
    "Yann Sommer": "یان زومر",
    "Alessandro Bastoni": "الساندرو باستونی",
    "Benjamin Pavard": "بنجامین پاوار",
    "Federico Dimarco": "فدریکو دی‌مارکو",
    "Nicolò Barella": "نیکولو بارلا",
    "Hakan Çalhanoğlu": "هاکان چالهان‌اوغلوتو",
    "Lautaro Martínez": "لاوتارو مارتینز",
    "Marcus Thuram": "مارکوس تورام",
    "Henrikh Mkhitaryan": "هنریخ مخیتاریان",
    "Piotr Zieliński": "پیوتر زیلینسکی",
    "Denzel Dumfries": "دنزل دومفریس",
    "Anatolij Trubin": "آناتولی تروبین",
    "Mike Maignan": "میک مینیان",
    "Theo Hernández": "تئو هرناندز",
    "Fikayo Tomori": "فیکایو توموری",
    "Rafael Leão": "رافائل لئائو",
    "Christian Pulisic": "کریستیان پولیسیچ",
    "Tijjani Reijnders Milan": "تیجانی رایندرس",
    "Alvaro Morata Milan": "آلوارو موراتا",
    "Youssouf Fofana": "یوسوف فوفانا",
    "Santiago Giménez": "سانتیاگو خیمنس",
    "Ruben Loftus-Cheek": "روبن لافتوس-چیک",
    "Alexis Saelemaekers": "الکسیس سالمکرز",
    "Gleison Bremer": "گلیسون برمر",
    "Dušan Vlahović": "دوشان ولاهوویچ",
    "Kenan Yıldız": "کنان ییلدیز",
    "Weston McKennie": "وستون مک‌کنی",
    "Michele Di Gregorio": "میکله دی گرجوریو",
    "Andrea Cambiaso": "آندره‌آ کامبیاسو",
    "Manuel Locatelli": "مانوئل لوکاتلی",
    "Teun Koopmeiners": "تئون کوپمینرس",
    "Douglas Luiz": "دوگلاس لوئیس",
    "Khéphren Thuram": "کفرن تورام",
    "Jonathan David": "جاناتان دیوید",
    "Randal Kolo Muani Juve": "راندال کولو موآنی",
    "Victor Osimhen": "ویکتور اوسیمهن",
    "Scott McTominay": "اسکات مک‌تومینی",
    "Kevin De Bruyne Napoli": "کوین دی‌بروینه",
    "Romelu Lukaku": "روملو لوکاکو",
    "Matteo Politano": "ماتئو پولیتانو",
    "Stanislav Lobotka": "استانیسلاو لوبوتکا",
    "Alex Meret": "الکس مرت",
    "Amir Rrahmani": "امیر رحمانی",
    "Giovanni Di Lorenzo": "جیوانی دی لورنزو",
    "Paulo Dybala": "پائولو دیبالا",
    "Artem Dovbyk": "آرتم دوبیک",
    "Lorenzo Pellegrini": "لورنزو پلگرینی",
    "Mile Svilar": "میله سویلار",
    "Evan Ndicka": "اوان ندیکا",
    "Ademola Lookman": "آدمولا لوکمن",
    "Charles De Ketelaere": "شارل دی کتلاره",
    "Éderson": "ادرसون آتلانتا",
    "Mario Pašalić": "ماریو پاسالیتش",
    "Nicolò Zaniolo": "نیکولو زانیولو",
    "Moise Kean": "موئیسه کئان",
    "Riccardo Orsolini": "ریکاردو اورسولینی",
    "Santiago Castro": "سانتیاگو کاسترو",
    "Moise Kean Fiorentina": "موئیسه کئان",
    "Albert Gudmundsson": "آلبرت گودموندسون",
    "Rolando Mandragora": "رولاندو ماند راگورا",
    "Nikola Krstović": "نیکولا کرستوویچ",

    // ---------- بوندسلیگا ----------
    "Manuel Neuer": "مانوئل نویر",
    "Joshua Kimmich": "یوشوا کیمیخ",
    "Jamal Musiala": "جامال موسیالا",
    "Thomas Müller": "توماس مولر",
    "Harry Kane": "هری کین",
    "Michael Olise": "مایکل اولیسه",
    "Dayot Upamecano": "دایو آپامکانو",
    "Alphonso Davies": "آلفونسو دیویس",
    "Serge Gnabry": "سرگ گنابری",
    "Leroy Sané": "لروی سانه",
    "Kingsley Coman": "کینگزلی کومان",
    "João Palhinha": "ژائو پالینها",
    "Luis Díaz Bayern": "لوئیس دیاز",
    "Jonathan Tah": "یوناتان تاه",
    "Granit Xhaka": "گرانیت شاکا",
    "Patrik Schick": "پاتریک شیک",
    "Florian Wirtz Leverkusen": "فلورین ویرتز",
    "Alejandro Grimaldo": "الخاندرو گریمالدو",
    "Robert Andrich": "رابرت آندریش",
    "Amine Adli": "امین عدلی",
    "Julian Brandt": "یولیان برانت",
    "Serhou Guirassy": "سرهو گویراسی",
    "Karim Adeyemi": "کریم آده‌می",
    "Niklas Süle": "نیکلاس زوله",
    "Gregor Kobel": "گرگور کوبل",
    "Marcel Sabitzer": "مارسل زابیتزر",
    "Julian Ryerson": "یولیان ری‌رسون",
    "Maximilian Beier": "ماکسیمیلیان بایر",
    "Felix Nmecha": "فلیکس نמکا",
    "Jobe Bellingham": "جوب بلینگام",
    "Davie Selke": "دیوی زلکه",
    "Nadiem Amiri": "نادی امیری",
    "Ransford Königsdörffer": "رانسفورد کونیکس‌دورفر",
    "Ermedin Demirović": "ارمدین دمیروویچ",

    // ---------- لیگ ۱ فرانسه ----------
    "Gianluigi Donnarumma": "جیانلوئیجی دوناروما",
    "Marquinhos": "مارکینیوس",
    "Achraf Hakimi": "اشرف حکیمی",
    "Nuno Mendes": "نونو مندس",
    "Vitinha": "ویتینیا",
    "João Neves": "ژائو نوس",
    "Fabián Ruiz": "فابیان رویز",
    "Ousmane Dembélé": "وسمان دمبله",
    "Bradley Barcola": "برادلی بارکولا",
    "Kvicha Kvaratskhelia": "خویچا کواراتسخلیا",
    "Désiré Doué": "دزیره دوئه",
    "Gonçalo Ramos": "گونسالو راموس",
    "Lucas Chevalier": "لوکا شوالییه",
    "Mason Greenwood": "میسون گرین‌وود",
    "Pierre-Emerick Aubameyang": "پیر-امریک اوبامپیانگ",
    "Amine Gouiri": "امین گویری",
    "Leon Balerdi": "لئون بالردی",
    "Luis Henrique": "لوئیس انریکه",
    "Corentin Tolisso": "کورنتین تولیسو",
    "Alexandre Lacazette": "الکساندر لاکازت",
    "Malick Fofana": "مالیک فوفانا",
    "Mikautadze": "ژرژ میخائوتادزه",
    "Emmanuel Agbadou": "امانوئل آگبادو",
    "Ludovic Ajorque": "لودویک آژورک",

    // ---------- لیگ هلند ----------
    "Remko Pasveer": "رمکو پاسفیر",
    "Kenneth Taylor": "کنت تیلور",
    "Steven Berghuis": "استیون برخیوس",
    "Wout Weghorst": "ووت وگهورست",
    "Mika Godts": "میکا خوتس",
    "Davy Klaassen": "دیوی کلاسن",
    "Youri Baas": "یوری باس",
    "Josip Šutalo": "یوسیپ شوتالو",
    "Olivier Boscagli": "الیویه بوسکالی",
    "Joey Veerman": "جوئی ویرمان",
    "Guus Til": "خوس تیل",
    "Ismael Saibari": "اسماعیل سیباری",
    "Ricardo Pepi": "ریکاردو پپی",
    "Ivan Perišić": "ایوان پریشیچ",
    "Anis Hadj Moussa": "انیس حج موسی",
    "Ayase Ueda": "آیاسه اوئدا",
    "Igor Paixão": "ایگور پایسائو",
    "Semen Istemin": "سمن ایستمین",

    // ---------- لیگ پرتغال ----------
    "Diogo Costa": "دیوگو کوستا",
    "Pepê": "پپه",
    "Vitor Roque": "ویتور روکه",
    "Rodrigo Mora": "رودریگو مورا",
    "Alan Varela": "آلان وارلا",
    "Agnese Rossi": "آگستو روسی",
    "Ángel Di María": "آنجل دی ماریا",
    "Kerem Aktürkoğlu": "کرم اکتورک‌اوغلو",
    "Vangelis Pavlidis": "وانگلیس پاولیدیس",
    "Fredrik Aursnes": "فردریک آورسنز",
    "Orkun Kökçü": "اورکون کاکچو",
    "Arthur Cabral": "آرتور کابرال",
    "Franco Prati": "فرانکو پراتی",

    // ---------- لیگ برزیل ----------
    "Gabriel Barbosa": "گابریل بارسلوشا",
    "Pedro Guimarães": "پدرو گیمارنش",
    "Arrascaeta": "جورجیان دی آراسکائتا",
    "Gerson": "جرسون",
    "Everton Ribeiro": "اورتون ریبیرو",
    "Estêvão": "استوائو",
    "Raphael Veiga": "رافائل ویگا",
    "Dudu": "دودو",
    "Lucas Moura": "لوکاس مورا",
    "Calleri": "جاناتان کالری",
    "Luciano": "لوسیانو",
    "Hulk": "هولک",
    "Paulinho": "پائولینیو",
    "Deyverson": "دیورسون",
    "Yuri Alberto": "یوری آلبرتو",
    "Rodrigo Garro": "رودریگو گارو",
    "Memphis Depay": "ممفیس دپای",
    "Germán Cano": "هرمان کانو",
    "John Kennedy": "جان کندی",
    "Igor Jesús": "ایگور ژسوس",

    // ---------- چمپیونشیپ ----------
    "Gustavo Hamer": "گوستاوو هامر",
    "Callum Wilson": "کالوم ویلسون",
    "Jayden Bogle": "جیدن بوگل",
    "Kieran Dewsbury-Hall": "کیرن دیوزبوری-هال",
    "Harry Kane ELC": "هری کین",
    "Martyn Waghorn": "مارتن واهورن",
    "Victor Johansson": "ویکتور یوهانسون",
    "Mads Frøkjær-Jensen": "مادس فرکی‌یر-ینسن",
    "Richard Kone": "ریچارد کونه",

    // ---------- لیگ قهرمانان / سایر ----------
    "Marc-André ter Stegen Barca": "مارک-آندره تر اشتگن",
    "Robert Sánchez GK": "رابرت سانچز",
    "Alisson": "الیسون",
    "Ederson Santana": "ادرسون",
    "Neymar": "نیمار",
    "Lionel Messi": "لیونل مسی",
    "Cristiano Ronaldo": "کریستیانو رونالدو",
};

// پست‌های بازیکن به فارسی
export const positionFa = {
    GOALKEEPER: 'دروازه‌بان',
    DEFENDER: 'مدافع',
    MIDFIELDER: 'هافبک',
    FORWARD: 'مهاجم',
};

// ملیت‌های پرتکرار به فارسی (کلید = نام انگلیسی football-data)
export const nationalityFa = {
    "Brazil": "برزیل",
    "Argentina": "آرژانتین",
    "France": "فرانسه",
    "England": "انگلیس",
    "Spain": "اسپانیا",
    "Germany": "آلمان",
    "Netherlands": "هلند",
    "Portugal": "پرتغال",
    "Italy": "ایتالیا",
    "Croatia": "کرواسی",
    "Belgium": "بلژیک",
    "Uruguay": "اروگوئه",
    "Morocco": "مراکش",
    "Japan": "ژاپن",
    "South Korea": "کرهٔ جنوبی",
    "Korea Republic": "کرهٔ جنوبی",
    "Ghana": "غنا",
    "Senegal": "سنگال",
    "Egypt": "مصر",
    "Nigeria": "نیجریه",
    "Ivory Coast": "ساحل عاج",
    "Côte d'Ivoire": "ساحل عاج",
    "Algeria": "الجزایر",
    "Tunisia": "تونس",
    "Iran": "ایران",
    "IR Iran": "ایران",
    "USA": "آمریکا",
    "United States": "آمریکا",
    "Mexico": "مکزیک",
    "Colombia": "کلمبیا",
    "Chile": "شیلی",
    "Norway": "نروژ",
    "Sweden": "سوئد",
    "Denmark": "دانمارک",
    "Poland": "لهستان",
    "Serbia": "صربستان",
    "Switzerland": "سوئیس",
    "Austria": "اتریش",
    "Ukraine": "اوکراین",
    "Russia": "روسیه",
    "Turkey": "ترکیه",
    "Türkiye": "ترکیه",
    "Greece": "یونان",
    "Czech Republic": "چک",
    "Slovakia": "اسلواکی",
    "Slovenia": "اسلوونی",
    "Scotland": "اسکاتلند",
    "Wales": "ولز",
    "Ireland": "ایرلند",
    "Republic of Ireland": "ایرلند",
    "Guinea": "گینه",
    "Mali": "مالی",
    "Cameroon": "کامرون",
    "DR Congo": "کنگو",
    "Congo DR": "کنگو",
    "Burkina Faso": "بورکینافاسو",
    "Gambia": "گامبیا",
    "Cape Verde": "کیپ‌ورد",
    "Cabo Verde": "کیپ‌ورد",
    "Gabon": "گابن",
    "Australia": "استرالیا",
    "Canada": "کانادا",
    "Peru": "پرو",
    "Ecuador": "اکوادور",
    "Venezuela": "ونزوئلا",
    "Paraguay": "پاراگوئه",
    "Bolivia": "بولیوی",
    "Hungary": "مجارستان",
    "Romania": "رومانی",
    "Bosnia and Herzegovina": "بوسنی",
    "North Macedonia": "مقدونیهٔ شمالی",
    "Albania": "آلبانی",
    "Kosovo": "کوزوو",
    "Montenegro": "مونته‌نگرو",
    "Georgia": "گرجستان",
    "Armenia": "ارمنستان",
    "Israel": "اسرائیل",
    "Saudi Arabia": "عربستان",
    "Uzbekistan": "ازبکستان",
    "Kazakhstan": "قزاقستان",
    "Finland": "فنلاند",
    "Iceland": "ایسلند",
};

// نام فارسی بازیکن — با برگشت به نام انگلیسی
export function playerNameFa(name) {
    return playerNames[name] || name;
}

// نام فارسی ملیت — با برگشت به انگلیسی
export function nationalityFaName(name) {
    return nationalityFa[name] || name;
}

// نام فارسی مربی‌های شاخص (کلید = نام دیتابیس/فوتبال‌دیتا) — با برگشت به انگلیسی
export const coachNames = {
    "Pep Guardiola": "پپ گواردیولا",
    "Josep Guardiola": "پپ گواردیولا",
    "Josep Guardiola i Sala": "پپ گواردیولا",
    "Carlo Ancelotti": "کارلو آنچلوتی",
    "Jürgen Klopp": "یورگن کلوپ",
    "Jurgen Klopp": "یورگن کلوپ",
    "Mikel Arteta": "میکل آرتتا",
    "Arne Slot": "آرنه اسلات",
    "Rúben Amorim": "روبن آموریم",
    "Ruben Amorim": "روبن آموریم",
    "Erik ten Hag": "اریک تن هاگ",
    "Diego Simeone": "دیگو سیمئونه",
    "Hansi Flick": "هانسی فلیک",
    "Xavi": "شاوی",
    "Xavi Hernández": "شاوی",
    "Xavi Hernández i Creus": "شاوی",
    "Simone Inzaghi": "سیمونه اینزاگی",
    "Antonio Conte": "آنتونیو کونته",
    "Massimiliano Allegri": "ماسیمیلیانو آلگری",
    "Stefano Pioli": "استفانو پیولی",
    "Unai Emery": "اونای امری",
    "Luis Enrique": "لوئیس انریکه",
    "Lionel Scaloni": "لیونل اسکالونی",
    "Didier Deschamps": "دیدیه دشان",
    "Julian Nagelsmann": "یولیان ناگلسمن",
    "Thomas Tuchel": "توماس توخل",
    "Enzo Maresca": "انتسو مارزکا",
    "Vincent Kompany": "ونسان کمپانی",
    "Oliver Glasner": "اولیور گلازنر",
    "Fabian Hürzeler": "فابیان هورزلر",
    "Thomas Frank": "توماس فرانک",
    "Andoni Iraola": "آندونی ایرولا",
    "Graham Potter": "گراهام پاتر",
    "Marco Silva": "مارکو سیلوا",
    "Paulo Fonseca": "پائولو فونسکا",
    "Sérgio Conceição": "سرجیو کونسیسائو",
    "Sergio Conceicao": "سرجیو کونسیسائو",
    "Francesco Farioli": "فرانچسکو فارولی",
    "Amir Ghalenoei": "امیر قلعه‌نویی",
    "Amir Ghalenoi": "امیر قلعه‌نویی",
    "Yahya Golmohammadi": "یحیی گل‌محمدی",
    "Farhad Majidi": "فرهاد مجیدی",
    "Mehdi Rahmati": "مهدی رحمتی",
    "Ali Daei": "علی دایی",
    "Javad Nekounam": "جواد نکونام",
};

// نام فارسی مربی — با برگشت به نام انگلیسی
export function coachNameFa(name) {
    return coachNames[name] || name;
}